import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as LiveIcon } from "../../assets/Icons/live.svg";
import { ReactComponent as InfoIcon } from "../../assets/Icons/info.svg";
import { ReactComponent as PrevArrow } from "../../assets/Icons/arrow-prev.svg";
import { ReactComponent as NextArrow } from "../../assets/Icons/arrow-next.svg";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import VideoJS from "../../Components/VideoJsPlayer/VideoJS";
import ScheduleDetailsModal from "../../Components/Modals/ScheduleDetailsModal";
import LiveEpgContainer from "./LiveEpgContainer";
import { useDispatch, useSelector } from "react-redux";
import { getVideoSubscription } from "../Subscription/service"
// import { fetchLiveChannels, fetchLiveChannels2 } from "./service";
import { fetchLiveChannels } from "./service";
import { getLiveScheduleData } from "../../Redux/LiveScheduleData/liveScheduleDataSlice";
import { convertUTCToLocal, getCurrentTime, getCurrentTimeAndDate, getDiffInMinutes, imageUrlCheck, onVideoPlayFunction, timeConversion } from "../../utils/utils";
import { getUserSubscription } from "../../network/service";
import { getUserSubscriptionData } from "../../Redux/UserSubscriptionDetails/userSubscriptionSlice";
import ContinueWithSubscriptionModal from "../../Components/Modals/ContinueWithSubscriptionModal";
import parse from "html-react-parser";
import moment from "moment";
import { getSelectedSchedule } from "../../Redux/SelectedScheduleChannel/selectedScheduleChannelSlice";
import NoScheduleAvailableModal from "../../Components/Modals/NoScheduleAvailableModal";
import { fetchFastChannels } from "./service";
import Translate from "../../Components/Multilanguage/Translate";
import { ReactComponent as RightArrow } from "../../assets/Icons/rightArrow.svg";
import { ReactComponent as PauseButton } from "../../assets/Icons/pause2.svg";
import { ReactComponent as PlayButton } from "../../assets/Icons/play2.svg";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import SwiperCore, { Navigation } from 'swiper';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

let debounce = true;
var videoStarted = false;
let seconds = 60;
let prevTime;
let initialLoad = true;
const LiveChannelsNew = () => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const sessionId = useSelector((state) => state?.sessionId?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const scheduleModal = useSelector((state) => state?.scheduleModal?.value);
  const liveScheduleData = useSelector((state) => state?.liveSchedule?.value);
  const selectedSchedule = useSelector((state) => state?.selectedSchedule?.value);
  const userSubscriptionData = useSelector((state) => state?.userSubscription?.value);
  const pubid = projectInfo?.projectConfig?.pubid;
  const buttonColor = projectInfo?.projectConfig?.config?.BUTTON_COLOR;
  const buttonSelectionColor = projectInfo?.projectConfig?.config?.BUTTON_SELECTION_COLOR;
  const textColor = projectInfo?.projectConfig?.config?.TEXT_COLOR;
  // const isPubId50183 = Number(pubid) === 50183 || String(pubid) === "50183";
  const isPubId50183 = true;
  const user = useSelector((state) => state?.user?.value);

  const [initialLoad, setInitialLoad] = useState(true);
  const [sliceCount, setSliceCount] = useState(550);
  const [channelData, setChannelData] = useState();
  const [livePlayer, setLivePlayer] = useState();
  const [isReadMore, setIsReadMore] = useState(true);
  const [timeLeft, setTimeLeft] = useState()
  const [liveUrl, setLiveUrl] = useState("")
  const [loading, setLoading] = useState(true)
  const [isReady, setIsReady] = useState(false);
  const [timerExpired, setTimerExpired] = useState(false);
  const [isContinueWithSubscriptionModal, setIsContinueWithSubscriptionModal] = useState(false);
  const [fastchannelData, setFastChannelData] = useState();
  const [isDetailsLoading, setIsDetailsLoading] = useState(true);
  const [isNoScheduleAvailableModal, setIsNoScheduleAvailableModal] = useState(false);
  const [categories, setCategories] = useState();
  const [categoryButton, setCategoryButton] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState();
  const [selectedCategoryName, setselectedCategoryName] = useState(categories?.[0]?.category_name || <Translate textKey={'select_category'} />);
  const [isCategoryChange, setIsCategoryChange] = useState(false);
  const [channelPoster, setChannelPoster] = useState();
  const [isLiveVideoSub, setLiveVideoSub] = useState();
  const [videoSubscription, setVideoSubscription] = useState();
  const [subscribedUser, setSubscribedUser] = useState();
  const [isRadioLive, setIsRadioLive] = useState(false);
  const [showSubscribe, setShowSubscribe] = useState(false)
  const [isLivePlaying, setIsLivePlaying] = useState(false);
  const [isLivePaused, setIsLivePaused] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const playerRef = useRef(null);
  const lastCheckedChannelIdRef = useRef(null);
  const isFetchingSubscriptionRef = useRef(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  SwiperCore.use([Navigation]);
  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
    sessionId,
  };
  const queryParams = new URLSearchParams(location.search);
  const c = queryParams.get('c');

  if (localStorage.getItem('initialLoaded') == 'true') {
    localStorage.removeItem('initialLoaded');
    setInitialLoad(false);
    // window.location.href = window.location.href;

  } else {
    // do nothing
  }

  // useEffect(() => {
  //   if(!selectedSchedule?.channel_id){
  //     if (liveScheduleData?.channels) {
  //       setChannelData(liveScheduleData?.channels[0]);
  //     }
  //   }
  // }, [liveScheduleData]);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Use 'auto' for instant scrolling
    });
  }, [])

  useEffect(() => {

    if (projectInfo?.projectConfig?.config?.LIVE_LOGIN_REQUIRED === "true" && !user) {
      const resolvedPrevPath = location?.state?.prevPath || location?.state?.backURL || "/home";
      if (projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED === 'true') {
        navigate("/checkout", {
          replace: true,
          state: {
            ...location.state,
            path: location?.pathname,
            prevPath: resolvedPrevPath,
          }
        });
      } else {
        navigate("/login", {
          replace: true,
          state: {
            ...location.state,
            path: location?.pathname,
            prevPath: resolvedPrevPath,
          }
        });
      }
      return;
    }
  }, []);

  useEffect(() => {
    // if (!isCategoryChange) {
    //   setChannelData(null);
    //   setFastChannelData(null);
    //   setLivePlayer(null);
    //   setLiveUrl(null);
    // }


    let selectedChannelId = null;
    if (c) {
      selectedChannelId = c;
    } else if (selectedSchedule?.channel_id) {
      selectedChannelId = selectedSchedule.channel_id;
    } else if (liveScheduleData?.schedules?.[0]?.channel_id) {
      selectedChannelId = liveScheduleData.schedules[0].channel_id;
    }

    if (!isCategoryChange) {

      if (!channelData || (selectedChannelId && selectedChannelId != channelData?.channel_id)) {
        setChannelData(null);
        setFastChannelData(null);
        setLivePlayer(null);
        setLiveUrl(null);
      }
    }
    if (liveScheduleData) {
      if (Object.entries(liveScheduleData).length > 0 && liveScheduleData.channels?.length > 0 && liveScheduleData?.schedules?.length > 0) {
        setLoading(false)
        setIsNoScheduleAvailableModal(false);

        // let selectedChannelId = null;
        // if (c) {
        //   selectedChannelId = c;
        // } else if (selectedSchedule?.channel_id) {
        //   selectedChannelId = selectedSchedule.channel_id;
        // } else if (liveScheduleData?.schedules[0]?.channel_id) {
        //   selectedChannelId = liveScheduleData.schedules[0].channel_id;
        // }

        if (selectedChannelId) {
          const filteredChannel = liveScheduleData?.channels?.find((item) => selectedChannelId == item?.id);
          if (filteredChannel) {
            if (!channelData || channelData?.channel_id != selectedChannelId || channelData?.id != filteredChannel?.id) {
              setChannelData({ ...filteredChannel, channel_id: selectedChannelId });
            }
          }
          if (!selectedSchedule?.channel_id || selectedSchedule.channel_id != selectedChannelId) {
            dispatch(getSelectedSchedule({ selectedSchedule: { channel_id: selectedChannelId } }));
          }
        }
      }
      else {
        if (liveScheduleData.channels?.length === 0 && liveScheduleData.schedules?.length === 0) {
          setIsNoScheduleAvailableModal(true);
        } else {
          setIsNoScheduleAvailableModal(false);
        }
      }
    }
    setIsCategoryChange(false);
    return () => localStorage.setItem("initialScheduleAdded", "false")
  }, [selectedSchedule, liveScheduleData, c]);

  useEffect(() => {
    // if (channelData?.live_link) {
    setShowSubscribe(false);
    setIsDetailsLoading(true);
    setLiveUrl("");
    checkSubscription();
    setIsLivePlaying(true);
    setIsLivePaused(false);
    // }
  }, [channelData, userSubscriptionData?.data]);

  useEffect(() => {
    if (fastchannelData?.now_playing?.end_time) {
      let time = getCurrentTimeAndDate();
      let currentTime = moment(time);
      let convertedEndTime = moment(fastchannelData?.now_playing?.end_time);
      let diff = convertedEndTime.diff(currentTime, "minutes");
      if (diff > 60) {
        setTimeLeft(timeConversion(diff));
      } else if (diff > 0) {
        let leftTime = diff + "m";
        setTimeLeft(leftTime);
      } else {
        setTimeLeft(null);
      }
    } else {
      setTimeLeft(null);
    }
  }, [fastchannelData]);

  useEffect(() => {
    if (fastchannelData?.now_playing?.start_time) {
      const interval = setInterval(() => {
        let diff = timeDifferenceHandler()
        if (diff > 60) {
          setTimeLeft(timeConversion(diff))
        } else if (diff > 0) {
          let leftTime = diff + "m"
          setTimeLeft(leftTime)
        }
      }, 60000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [fastchannelData, timeLeft])

  const timeDifferenceHandler = () => {
    let time = getCurrentTimeAndDate()
    let currentTime = moment(time)
    let convertedEndTime = moment(fastchannelData?.now_playing?.end_time)
    let differenceInMinutes = convertedEndTime.diff(currentTime, "minutes")
    return differenceInMinutes
  }


  useEffect(() => {
    if (liveUrl) {
      const videoJsOptions = {
        autoplay: true,
        muted: true,
        controls: true,
        responsive: true,
        fluid: true,
        playsinline: true,
        html5: {
          nativeTextTracks: false
        },
        controlBar: {
          pictureInPictureToggle: false,
        },
        sources: [
          {
            src: `${liveUrl}`,
            type: "application/x-mpegURL",
          },
        ],
        poster: channelPoster
      };
      setLivePlayer(
        <VideoJS options={videoJsOptions} liveData={fastchannelData} onReady={handlePlayerReady} is_live={true} poster={channelPoster} isRadioLive={isRadioLive} watermark={fastchannelData?.watermark} />
      );
    }
    else {
      setLivePlayer(null);
    }
  }, [liveUrl]);

  useEffect(() => {
    window.scroll(0, 0);
    fetchUserSubscriptionDetails();
  }, []);

  useEffect(() => {
    if (liveScheduleData?.categories?.length > 0) {
      const formattedCategories = liveScheduleData.categories.map(cat => ({
        ...cat,
        category_name: formatCategoryName(cat?.category_name)
      }));
      setCategories(formattedCategories);
      const firstCategory = formattedCategories?.[0];
      if (firstCategory && !selectedCategory) {
        setSelectedCategory(firstCategory);
        setselectedCategoryName(firstCategory.category_name);
      }
      setPageLoading(false);
    }
  }, [liveScheduleData]);

  const formatCategoryName = (name) => {
    if (!name || typeof name !== 'string') return name;
    return name.replace(/\s*\(/g, ' ').replace(/\)/g, '').replace(/\s+/g, ' ').trim();
  };

  const fetchLiveCategories = async () => {
    let fetchedCategories = liveScheduleData?.categories;
    if (!fetchedCategories || fetchedCategories.length === 0) {
      const fastChannelResponse = await fetchLiveChannels(appInfo);
      if (fastChannelResponse?.status === 200) {
        fetchedCategories = fastChannelResponse?.data?.data?.categories;
      }
    }
    if (fetchedCategories?.length > 0) {
      const formattedCategories = fetchedCategories?.map(cat => ({
        ...cat,
        category_name: formatCategoryName(cat?.category_name)
      }));
      setCategories(formattedCategories);
      const firstCategory = formattedCategories?.[0];
      if (firstCategory && !selectedCategory) {
        setSelectedCategory(firstCategory);
        setselectedCategoryName(firstCategory.category_name);
      }
      setPageLoading(false);
    }
  };
  const fetchUserSubscriptionDetails = async () => {
    const userSubResponse = await getUserSubscription(appInfo);
    if (userSubResponse?.status === 200) {
      dispatch(
        getUserSubscriptionData({
          userSubscription: userSubResponse?.data,
        })
      );
    }
  };


  const checkSubscription = async () => {
    let channelId;
    if (c) {
      channelId = c;
    } else if (location?.state?.homelive === true && location?.state?.channelId) {
      channelId = location.state.channelId;
    } else if (channelData?.channel_id) {
      channelId = channelData.channel_id;
    } else {
      channelId = null;
    }

    if (!channelId) {
      return;
    }

    if (lastCheckedChannelIdRef.current === channelId && isFetchingSubscriptionRef.current) {
      return;
    }
    if (lastCheckedChannelIdRef.current === channelId && fastchannelData) {
      return;
    }

    lastCheckedChannelIdRef.current = channelId;
    isFetchingSubscriptionRef.current = true;

    const appInfo = {
      projectDetails: projectInfo,
      accessToken: accessToken,
    };

    try {
      const fastChannelResponse = await fetchFastChannels(appInfo, channelId);

      let fastchannelInfo;
      if (fastChannelResponse?.status === 200) {
        const fastchannelInfo = Array.isArray(fastChannelResponse?.data?.data)
          ? fastChannelResponse?.data?.data?.[0]
          : fastChannelResponse?.data?.data;

        if (fastchannelInfo) {
          setFastChannelData({ ...fastchannelInfo });
          setSubscribedUser(true);
          setIsContinueWithSubscriptionModal(false);

          if (fastchannelInfo?.subscriptions) {
            setLiveVideoSub(fastchannelInfo.subscriptions);
          }

          if (fastchannelInfo?.logo) {
            setChannelPoster(fastchannelInfo.logo || fastchannelInfo.logo_thumb);
          } else {
            setChannelPoster(projectInfo?.projectConfig?.config?.PLACEHOLDER_IMAGE);
          }

          setLiveUrl(fastchannelInfo?.live_link);

          setTimeout(() => {
            setShowSubscribe(true);
          }, 2000);
        }
      } else if (fastChannelResponse?.status === 401) {
        setSubscribedUser(false);
        const resolvedPrevPath = location?.state?.prevPath || location?.state?.backURL || "/home";
        navigate(projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED === "true" ? "/checkout" : "/login", {
          replace: true,
          state: {
            ...location.state,
            path: location?.pathname,
            prevPath: resolvedPrevPath,
            from: "LiveChannels"
          }
        });
      } else if (fastChannelResponse?.status === 403) {
        const channelInfo = channelData || liveScheduleData?.channels?.find((item) => channelId == item?.id);
        const fastchannelInfo = (Array.isArray(fastChannelResponse?.data?.data)
          ? fastChannelResponse?.data?.data?.[0]
          : fastChannelResponse?.data?.data) || channelInfo;

        if (fastchannelInfo) {
          setFastChannelData({
            ...fastchannelInfo,
            subscribe_message: fastChannelResponse?.data?.message || fastchannelInfo?.subscribe_message || "Subscribe now to get access to stream premium content."
          });
          if (fastchannelInfo?.logo || fastchannelInfo?.logo_thumb) {
            setChannelPoster(fastchannelInfo.logo || fastchannelInfo.logo_thumb);
          } else {
            setChannelPoster(projectInfo?.projectConfig?.config?.PLACEHOLDER_IMAGE);
          }
        }
        setSubscribedUser(false);
        setLiveUrl("");
        setLivePlayer(null);
        setIsContinueWithSubscriptionModal(true);
        setShowSubscribe(true);
      } else if (fastChannelResponse?.status === 419) {
        setSubscribedUser(false);
        const alertMsg = fastChannelResponse?.data?.message || "Session expired. Please log in again.";
        alert(alertMsg);
        localStorage.removeItem("userId");
        localStorage.removeItem("token");
        localStorage.removeItem("sessionId");
        localStorage.removeItem("gid");
        window.location.href = "/login";
      }
    } catch (err) {
      console.error("Error in checkSubscription:", err);
    } finally {
      isFetchingSubscriptionRef.current = false;
      setIsDetailsLoading(false);
    }
  };

  const matchSubscription = async (userSub, videoSub) => {
    const hasMatch = videoSub.length == 0 ? true : userSub.some((user) => videoSub.some((video) => user.sub_id === video.subscription_id));
    return hasMatch;
  };


  const handlePlayerReady = (player) => {
    playerRef.current = player;
    try {
      player.muted(true);
      player.play().catch(() => { });
    } catch (e) {
      console.warn('Mute/play on ready failed:', e);
    }

    player.on("play", () => {
      let event = videoStarted == true ? "POP09" : "POP02";
      videoStarted = true;
      updateLiveAnalytics(
        channelData,
        event,
        player.currentTime()
      );
    });

    player.on("timeupdate", function (e) {
      let event = "POP03";

      var hasPlayedTime = player.currentTime();
      var intPlayedTime = parseInt(hasPlayedTime, 10);
      var isSixty = intPlayedTime % seconds === 0 && intPlayedTime !== 0;
      if (isSixty && debounce) {
        debounce = false;
        prevTime = intPlayedTime;
        updateLiveAnalytics(
          channelData,
          event,
          player.currentTime()
        );
      } else {
        if (debounce == false && prevTime != intPlayedTime) {
          debounce = true;
        }
      }
    });

    player.on("pause", () => {
      let event = "POP04";
      updateLiveAnalytics(
        channelData,
        event,
        player.currentTime()
      );
    });
    player.on("ended", () => {
      let event = "POP05";
      updateLiveAnalytics(
        channelData,
        event,
        player.currentTime()
      );
    });


    player.on("dispose", () => {
      videoStarted = false;
      // player.pause();
    });

    const videoElement = player.el()?.querySelector("video");
    let wasPlayingBeforeNativeFullscreen = false;
    let wasMutedBeforeNativeFullscreen = true;

    const handleNativeFullscreenStart = () => {
      wasPlayingBeforeNativeFullscreen = !player.paused();
      wasMutedBeforeNativeFullscreen = player.muted();
    };

    const handleNativeFullscreenEnd = () => {
      if (player.isDisposed()) {
        return;
      }

      const resumeInlinePlayback = () => {
        if (player.isDisposed()) {
          return;
        }

        player.controls(true);
        player.muted(wasMutedBeforeNativeFullscreen);
        const playRequest = player.play();
        playRequest?.catch(() => {
          if (videoElement) {
            videoElement.muted = true;
            videoElement.play().catch(() => { });
          }
        });
      };

      window.setTimeout(resumeInlinePlayback, 100);
      window.setTimeout(resumeInlinePlayback, 400);
    };

    videoElement?.addEventListener("webkitbeginfullscreen", handleNativeFullscreenStart);
    videoElement?.addEventListener("webkitendfullscreen", handleNativeFullscreenEnd);
    player.one("dispose", () => {
      videoElement?.removeEventListener("webkitbeginfullscreen", handleNativeFullscreenStart);
      videoElement?.removeEventListener("webkitendfullscreen", handleNativeFullscreenEnd);
    });

    const captionButtons = player.el()?.querySelectorAll(
      ".vjs-subs-caps-button, .vjs-subtitles-button, .vjs-captions-button"
    );

    captionButtons?.forEach((button) => {
      let captionMenuOpen = false;
      const menu = button.querySelector(".vjs-menu");

      const handleCaptionButtonClick = () => {
        if (!captionMenuOpen) {
          captionMenuOpen = true;
          return;
        }

        window.setTimeout(() => {
          button.classList.remove("vjs-hover", "vjs-lock-showing");
          menu?.classList.remove("vjs-lock-showing");
          button.blur();
          captionMenuOpen = false;
        }, 0);
      };

      const resetCaptionMenuState = (event) => {
        if (event.pointerType !== "touch") {
          captionMenuOpen = false;
        }
      };

      button.addEventListener("click", handleCaptionButtonClick);
      button.addEventListener("pointerleave", resetCaptionMenuState);
      player.one("dispose", () => {
        button.removeEventListener("click", handleCaptionButtonClick);
        button.removeEventListener("pointerleave", resetCaptionMenuState);
      });
    });
  };

  const updateLiveAnalytics = async (nowPlaying, event, time) => {
    const isLive = "1";
    const updateResponse = await onVideoPlayFunction(
      appInfo,
      nowPlaying,
      event,
      time,
      isLive
    );
  };

  const readMoreOrLessHandler = (type) => {
    if (type === "more") {
      if (channelData?.video_description) {
        setSliceCount(channelData?.video_description?.length);
        setIsReadMore(false);
      }
    } else {
      setSliceCount(550);
      setIsReadMore(true);
    }
  };

  const ContinueWatchingHandler = async () => {
    localStorage.setItem('initialLoaded', 'true');
    const resolvedPrevPath = location?.state?.prevPath || location?.state?.backURL || location?.pathname;
    if (projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED == 'true') {
      navigate("/checkout", { replace: true, state: { ...location.state, channelId: channelData?.channel_id, prevPath: resolvedPrevPath } });
    } else {

      if (!user) {
        navigate("/login", { replace: true, state: { ...location.state, path: location?.pathname, prevPath: resolvedPrevPath } });
      } else {
        navigate("/subscription", {
          replace: true,
          state: { ...location.state, channelId: channelData?.channel_id, prevPath: resolvedPrevPath },
        });
      }
    }
  };
  const handleCategorySelection = (item) => {
    setIsCategoryChange(true);
    setSelectedCategory(item);
    setselectedCategoryName(item?.category_name);
    setCategoryButton(false);
  };
  const handleWatchNowLive = () => {
    if (!subscribedUser) {
      setIsContinueWithSubscriptionModal(true);
      return;
    }
    if (fastchannelData?.live_link) {
      setLiveUrl(fastchannelData.live_link);
      setIsLivePlaying(true);
      setIsLivePaused(false);
    }
    const videoContainer = document.querySelector('.videoContainer');
    if (videoContainer) {
      videoContainer.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handlePauseLive = () => {
    setIsLivePaused(true);
    setIsLivePlaying(false);
  };

  const categoriesRowRef = useRef(null);

  const handleLeftScroll = () => {
    if (categoriesRowRef.current) {
      categoriesRowRef.current.scrollBy({ left: -200, behavior: 'smooth' });
    }
  };

  const handleRightScroll = () => {
    if (categoriesRowRef.current) {
      categoriesRowRef.current.scrollBy({ left: 200, behavior: 'smooth' });
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // if(!isReady){
  //   return <Loading />
  // }



  return (
    <div
      className={`LiveChannelsNewContainer${isPubId50183 ? ' pubid-50183' : ''}`}
      style={{
        ...(buttonColor ? { '--epg-btn-color': buttonColor } : {}),
        // ...(buttonSelectionColor ? { '--epg-selection-color': buttonSelectionColor } : {}),
        ...(textColor ? { '--epg-text-color': textColor } : {})
      }}
    >
      {scheduleModal?.isOpen && <ScheduleDetailsModal />}

      {isContinueWithSubscriptionModal && (<ContinueWithSubscriptionModal
        setIsContinueWithSubscriptionModal={setIsContinueWithSubscriptionModal}
        channelData={channelData}
        appInfo={appInfo}
      />
      )}

      {isNoScheduleAvailableModal && <NoScheduleAvailableModal />}

      {
        !loading &&
        (
          <div className="topContainer">
            <div className="wrapper">
              <div className="bannerContainer"
                role="main"
                aria-label="Live channel information">
                {isDetailsLoading || !fastchannelData ? (
                  <div className="info" aria-label="Loading channel details">
                    {isPubId50183 ? (
                      <>
                        <div className="eyebrow" style={{ marginBottom: 14 }}>
                          <Skeleton width={100} height={14} baseColor="rgba(255, 255, 255, 0.12)" highlightColor="rgba(255, 255, 255, 0.25)" borderRadius={4} />
                        </div>
                        <h1 id="channel-title" className="title" style={{ marginTop: 0, marginBottom: 10 }}>
                          <Skeleton width={180} height={34} baseColor="rgba(255, 255, 255, 0.12)" highlightColor="rgba(255, 255, 255, 0.25)" borderRadius={6} />
                        </h1>
                        <h2 className="videotitle" id="video-title" style={{ marginTop: 0, marginBottom: 18 }}>
                          <Skeleton width={240} height={18} baseColor="rgba(255, 255, 255, 0.12)" highlightColor="rgba(255, 255, 255, 0.25)" borderRadius={6} />
                        </h2>
                        <div className="additionalInfo" aria-label="Channel details" style={{ display: 'flex', gap: 8, marginBottom: 24 }}>
                          <Skeleton width={45} height={24} baseColor="rgba(255, 255, 255, 0.12)" highlightColor="rgba(255, 255, 255, 0.25)" borderRadius={6} />
                          <Skeleton width={95} height={24} baseColor="rgba(255, 255, 255, 0.12)" highlightColor="rgba(255, 255, 255, 0.25)" borderRadius={6} />
                          <Skeleton width={75} height={24} baseColor="rgba(255, 255, 255, 0.12)" highlightColor="rgba(255, 255, 255, 0.25)" borderRadius={6} />
                        </div>
                      </>
                    ) : (
                      <>
                        <h1 id="channel-title" className="title" style={{ marginBottom: 10 }}>
                          <Skeleton width={180} height={34} baseColor="rgba(255, 255, 255, 0.12)" highlightColor="rgba(255, 255, 255, 0.25)" borderRadius={6} />
                        </h1>
                        <h2 className="videotitle" id="video-title" style={{ marginBottom: 14 }}>
                          <Skeleton width={240} height={18} baseColor="rgba(255, 255, 255, 0.12)" highlightColor="rgba(255, 255, 255, 0.25)" borderRadius={6} />
                        </h2>
                        <div style={{ marginBottom: 16 }}>
                          <Skeleton count={2} height={14} baseColor="rgba(255, 255, 255, 0.12)" highlightColor="rgba(255, 255, 255, 0.25)" borderRadius={4} style={{ marginBottom: 6 }} />
                        </div>
                        <div className="additionalInfo" aria-label="Channel details" style={{ display: 'flex', gap: 8 }}>
                          <Skeleton width={70} height={24} baseColor="rgba(255, 255, 255, 0.12)" highlightColor="rgba(255, 255, 255, 0.25)" borderRadius={6} />
                          <Skeleton width={90} height={24} baseColor="rgba(255, 255, 255, 0.12)" highlightColor="rgba(255, 255, 255, 0.25)" borderRadius={6} />
                        </div>
                      </>
                    )}
                  </div>
                ) : (
                  <div className="info" aria-labelledby="channel-title">
                    {isPubId50183 && (
                      <div className="eyebrow">
                        <span className="liveDot"></span> On air now
                      </div>
                    )}
                    {fastchannelData?.channel_name && <h1 id="channel-title" className="title">{isPubId50183 ? fastchannelData?.channel_name : <><Translate textKey={'channel'} />: {fastchannelData?.channel_name}</>}</h1>}
                    <h2 className="videotitle" id="video-title">{fastchannelData?.now_playing?.video_title}</h2>
                    {!isPubId50183 && (
                      <p className="description" role="region" aria-labelledby="video-title">
                        {fastchannelData?.now_playing?.description && (
                          <>
                            {parse(
                              fastchannelData?.now_playing?.description
                                ?.slice(0, sliceCount)
                                ?.split("\n")
                                ?.join("<br>")
                            )}
                            {fastchannelData?.now_playing?.description?.length > sliceCount && (
                              <>
                                {isReadMore ? (
                                  <>
                                    <span>...</span>
                                    <span className="readMore" onClick={() => readMoreOrLessHandler("more")}
                                      type="button"
                                      onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                          e.preventDefault();
                                          readMoreOrLessHandler("more");
                                        }
                                      }}
                                      aria-label="Read full description"
                                      aria-expanded="false"
                                      tabIndex={0}
                                    >
                                      <Translate textKey={'read_more'} />
                                    </span>
                                  </>
                                ) : null}
                              </>
                            )}
                            {!isReadMore && (
                              <span className="readLess" onClick={() => readMoreOrLessHandler("less")}
                                type="button"
                                onKeyDown={(e) => {
                                  if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    readMoreOrLessHandler("less");
                                  }
                                }}
                                aria-label="Show less description"
                                aria-expanded="true"
                                tabIndex={0}
                              >
                                <Translate textKey={'read_less'} />
                              </span>
                            )}
                          </>
                        )}
                      </p>
                    )}
                    {isPubId50183 ? (
                      <div className="additionalInfo" aria-label="Channel details">
                        {fastchannelData?.rating && <span>{fastchannelData?.rating}</span>}
                        {fastchannelData?.categories?.[0] && <span>{fastchannelData?.categories[0]?.category_name}</span>}
                        {timeLeft && <span>{timeLeft} <Translate textKey={'left_small'} /></span>}
                      </div>
                    ) : (
                      <div className="additionalInfo" aria-label="Channel details">
                        {(fastchannelData?.rating || timeLeft || fastchannelData?.categories) && <h1 className="title"><Translate textKey={'watch_live_tv'} /></h1>}
                        <ul aria-label="Channel information">
                          {fastchannelData?.rating && <li>{fastchannelData?.rating}</li>}
                          {timeLeft && <li>{timeLeft} <Translate textKey={'left_small'} /></li>}
                          {fastchannelData?.categories[0] && <li>{fastchannelData?.categories[0]?.category_name}</li>}
                        </ul>
                        {channelData?.rating && <span className="rating" aria-label={`Content rating: ${channelData?.rating}`}>{channelData?.rating}</span>}
                      </div>
                    )}
                  </div>
                )}
                <div className="buttonsContainer" aria-label="Video controls">
                  {isPubId50183 ? (
                    <button
                      className="watchBtn"
                      onClick={isLivePlaying && !isLivePaused ? handlePauseLive : handleWatchNowLive}
                      type="button"
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          if (isLivePlaying && !isLivePaused) {
                            handlePauseLive();
                          } else {
                            handleWatchNowLive();
                          }
                        }
                      }}
                      aria-label={isLivePlaying && !isLivePaused ? "Pause live stream" : "Play live stream"}
                      tabIndex={0}
                    >
                      {isLivePlaying && !isLivePaused ? (
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"></path></svg>
                      ) : (
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"></path></svg>
                      )}
                      {isLivePlaying && !isLivePaused ? "Pause" : "Watch"}
                    </button>
                  ) : (
                    <div className="live-button live-switch-container">
                      {isLivePlaying && !isLivePaused ? (
                        <button onClick={handlePauseLive}
                          type="button"
                          className="switch-btn active"
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                              e.preventDefault();
                              handlePauseLive();
                            }
                          }}
                          aria-label="Pause live stream"
                          aria-pressed={isLivePaused ? "true" : "false"}
                          tabIndex={0}
                        >
                          <PauseButton aria-hidden="true" /> LIVE TV
                        </button>
                      ) : (
                        <button onClick={handleWatchNowLive}
                          type="button"
                          className="switch-btn active"
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                              e.preventDefault();
                              handleWatchNowLive();
                            }
                          }}
                          aria-label="Play live stream"
                          aria-pressed={isLivePlaying ? "true" : "false"}
                          tabIndex={0}
                        >
                          <PlayButton aria-hidden="true" /> LIVE TV
                        </button>
                      )}
                      <button
                        onClick={() => navigate('/home')}
                        type="button"
                        className="switch-btn on-demand-btn"
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            navigate('/home');
                          }
                        }}
                        aria-label="Go to On Demand"
                        tabIndex={0}
                      >
                        ON DEMAND
                      </button>
                    </div>
                  )}
                </div>
              </div>
              <div className={`videoContainer${isPubId50183 ? ' pubid-50183-video' : ''}`} aria-describedby="video-title" style={isPubId50183 ? { boxShadow: 'none', borderRadius: '12px' } : {}}>
                {isPubId50183 && (
                  <span className="liveBadge">
                    <span className="liveDot"></span>LIVE
                  </span>
                )}
                <div className="videoFrame">
                  {!isDetailsLoading && isLivePlaying && !isLivePaused && liveUrl && subscribedUser && livePlayer ? (
                    <>
                      {livePlayer}
                    </>
                  ) : (
                    <div className="videoImageContainer" style={{ width: '100%' }}>
                      {isDetailsLoading && !fastchannelData && !channelData ? (
                        <div className="video-loader-spinner">
                          <span className="loader-spinner"></span>
                        </div>
                      ) : (
                        <div className="banner-image" style={{ width: '100%' }}
                          role="img"
                          aria-labelledby="channel-title"
                        >
                          {(() => {
                            const displayLogo = fastchannelData?.logo || fastchannelData?.logo_thumb || channelPoster || channelData?.logo || channelData?.logo_thumb;
                            if (displayLogo) {
                              return imageUrlCheck(displayLogo) ? (
                                <img src={displayLogo} alt={`${fastchannelData?.channel_name || channelData?.channel_name || 'Channel'} logo`} style={{ width: '100%', height: '100%', objectFit: 'contain' }} loading="lazy" />
                              ) : (
                                <img
                                  src={`${process.env.REACT_APP_IMAGE_URL}${displayLogo}`}
                                  alt={`${fastchannelData?.channel_name || channelData?.channel_name || 'Channel'} logo`}
                                  style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                  loading="lazy"
                                />
                              );
                            }
                            return (
                              <div className="video-loader-spinner">
                                <span className="loader-spinner"></span>
                              </div>
                            );
                          })()}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )
      }
      {
        !subscribedUser && showSubscribe && (
          <div className="banner-text"
            role="alert"
            aria-live="polite"
            aria-label="Subscription required"
          >
            <h2>{fastchannelData?.subscribe_message || videoSubscription?.data?.subscribe_message || "Subscribe now to get access to stream premium content."}</h2>
            <button onClick={ContinueWatchingHandler}
              type="button"
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  ContinueWatchingHandler();
                }
              }}
              aria-describedby="subscription-message"
              aria-label="Proceed to subscription"
              tabIndex={0}><Translate textKey={'proceed'} /></button>
          </div>
        )}
      {categories && categories?.length > 0 && (
        <div className={`categories-row-wrapper${isPubId50183 ? ' pubid-50183-categories' : ''}`} role="region" aria-label="Channel categories" style={isPubId50183 ? { border: '1px solid rgba(255, 196, 192, 0.14)', padding: '0px', height: '65px' } : {}}>
          <button className="arrow-btn left category-arrow-btn"
            type="button"
            aria-label="Scroll categories left"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
              }
            }}
          >
            <span aria-hidden="true"><RightArrow /></span>
          </button>
          <Swiper
            slidesPerView="auto"
            spaceBetween={10}
            navigation={{
              nextEl: '.arrow-btn.right.category-arrow-btn',
              prevEl: '.arrow-btn.left.category-arrow-btn',
            }}
            className="categories-row"
            role="group"
            aria-label="Category selection"
          >
            {categories?.map((item, index) => (
              <SwiperSlide key={index} style={{ width: 'auto' }}>
                <div
                  className={`category-btn${selectedCategory?.category_id === item?.category_id ? ' selected' : ''}`}
                  onClick={() => handleCategorySelection(item)}
                  type="button"
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      handleCategorySelection(item);
                    }
                    else if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
                      e.preventDefault();
                      const direction = e.key === 'ArrowLeft' ? -1 : 1;
                      const nextIndex = Math.max(0, Math.min(categories.length - 1, index + direction));
                      const nextButton = document.querySelectorAll('.category-btn')[nextIndex];
                      if (nextButton) {
                        nextButton.focus();
                      }
                    }
                  }}
                  role="tab"
                  aria-selected={selectedCategory?.category_id === item?.category_id}
                  tabIndex={selectedCategory?.category_id === item?.category_id ? 0 : -1}
                  aria-label={`${formatCategoryName(item?.category_name)} category${selectedCategory?.category_id === item?.category_id ? ', currently selected' : ''}`}
                >
                  <span>{formatCategoryName(item?.category_name)}</span>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <button className="arrow-btn right category-arrow-btn"
            type="button"
            aria-label="Scroll categories right"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
              }
            }}
          >
            <span aria-hidden="true"><RightArrow /></span>
          </button>
        </div>
      )}



      <LiveEpgContainer
        selectedCategory={selectedCategory}
      />
    </div>
  );
};

export default LiveChannelsNew;
